import { CheckIcon, ChevronDownIcon, SmallCloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Spinner,
  Table,
  TableCaption,
  TableContainer,
  Tag,
  TagLabel,
  TagRightIcon,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import API from "../../api";
import { useAppContext } from "../../context/index";
import logger from "../../utils/logger";

const Stores = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const { partner, setPartner, fetchPartner } = useAppContext();
  const [partnerData, setPartnerData] = useState([]);

  const fetchOverviewData = async ({
    from = new Date(new Date(Date.now()).setHours(0, 0, 0, 0)),
    to = new Date(new Date(Date.now()).setHours(23, 59, 59, 999)),
    appEnabled = false,
    partnerEnabled = false,
  }) => {
    try {
      console.log("get data", from, to, appEnabled, partnerEnabled);
      setLoading(true);
      await API(
        "/analytics/store-features?" +
          new URLSearchParams({
            from,
            to,
            appEnabled,
            partnerEnabled,
          }),
        "GET"
      )
        .then((data) => {
          console.log(data);
          if (data && data?.storesList?.length > 0) {
            const tableData = data?.storesList.map((store, index) => {
              return {
                storeUrl: store?.storeUrl,
                appEnabled: store?.appEnabled,
                appName: store?.appName,
                listOfFeatures: store?.listOfFeatures,
              };
            });
            setTableData(tableData);
            setPartnerData(data);
          } else {
            toast({
              title: "No data found!",
              description: "No data found!",
              // Please try again with different date range!",
              status: "warning",
              duration: 2000,
              isClosable: true,
            });
          }
        })
        .catch((err) => {
          toast({
            title: "Error in fetching data!",
            description: err?.error ?? "Internal Server Error!",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
          console.log("error", err);
        });
      setLoading(false);
    } catch (error) {
      logger({
        functionName: "OverView Anlytics Data.initializeAnalyticsData",
        error,
        sentry: true,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOverviewData({});
  }, []);

  return (
    <>
      {" "}
      <div
        className="form-box"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          margin: "0px -20px",
        }}
      >
        {" "}
        {loading ? (
          <Center bg="white" h="100px">
            <Spinner />
          </Center>
        ) : (
          <Box>
            <TableContainer>
              <Table variant="striped" colorScheme="gray">
                <TableCaption>
                  Please Go to Settings to Generate the token and integrate it
                  on Codfirm to see your earned commision.
                </TableCaption>
                <Thead>
                  <Tr>
                    <Th>S No.</Th>
                    <Th>Store Url</Th>
                    <Th>App Name</Th>
                    <Th>App Enabled</Th>
                    <Th>
                      <Flex
                        alignItems="center"
                        justifyContent="flex-start"
                        background={"white"}
                      >
                        <div style={{ paddingRight: "20px" }}>
                          List of Features{" "}
                        </div>
                        <Tag
                          size="sm"
                          borderRadius="full"
                          variant="solid"
                          colorScheme="green"
                          margin={"5px"}
                        >
                          <TagLabel>{"Enabled"}</TagLabel>
                          <TagRightIcon as={CheckIcon} />
                        </Tag>
                        <Tag
                          size="sm"
                          borderRadius="full"
                          variant="solid"
                          colorScheme="red"
                          margin={"5px"}
                        >
                          <TagLabel>{"Disabled"}</TagLabel>
                          <TagRightIcon as={SmallCloseIcon} />
                        </Tag>
                      </Flex>
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {tableData?.length ? (
                    tableData.map((row, index) => {
                      const listOfFeatures = row?.listOfFeatures.map(
                        (feature, index) => {
                          if (feature?.value === true) {
                            return (
                              <div className="abcd">
                                <Tag
                                  size="lg"
                                  key={index}
                                  borderRadius="full"
                                  variant="solid"
                                  colorScheme="green"
                                  margin={"5px"}
                                >
                                  <TagLabel>{feature?.label}</TagLabel>
                                  <TagRightIcon as={CheckIcon} />
                                </Tag>
                              </div>
                            );
                          }
                          return (
                            <div className="abcd">
                              <Tag
                                size="lg"
                                key={index}
                                borderRadius="full"
                                variant="solid"
                                colorScheme="red"
                                margin={"5px"}
                              >
                                <TagLabel>{feature?.label}</TagLabel>
                                <TagRightIcon as={SmallCloseIcon} />
                              </Tag>
                            </div>
                          );
                        }
                      );

                      return (
                        <Tr>
                          <Td>{index + 1}</Td>
                          <Td>
                            <a href={"https://" + row?.storeUrl}>
                              {row?.storeUrl}
                            </a>
                          </Td>
                          <Td>{row?.appName}</Td>
                          <Td>
                            {row?.appEnabled ? (
                              <CheckIcon />
                            ) : (
                              <SmallCloseIcon />
                            )}
                          </Td>

                          <Td>
                            {listOfFeatures.slice(0, 3)}{" "}
                            <Popover>
                              <PopoverTrigger>
                                <Button>
                                  <ChevronDownIcon />
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader>More Features</PopoverHeader>
                                <PopoverBody>
                                  {listOfFeatures.slice(3)}
                                </PopoverBody>
                              </PopoverContent>
                            </Popover>
                          </Td>
                        </Tr>
                      );
                    })
                  ) : (
                    <>No data found</>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </div>
    </>
  );
};

export default Stores;
